import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { ActivityCategory } from '@/entities/activities/ActivityCategory'
import { Activity } from '@/entities/activities/Activity'
import { ReservationMethod, AttendeeType } from '@/entities/activities/ReservationMethod'
import { ActivityGroup } from '@/entities/activities/ActivityGroup'
import { SlotCapacity } from '@/entities/activities/SlotCapacity'
import { CatalogWithCategoriesAndProducts } from '@/entities/Catalog'
import { APP_FACILITY_ID } from '@/config/environment'
import camelcaseKeys from 'camelcase-keys'

const requestService = new RequestService()

export class ActivitiesRequests {
  listActivityCategories () {
    const route = ServerDirections.ACTIVITY_CATEGORIES
    const method = 'get'
    const params = { facility_id: APP_FACILITY_ID}
    function map (data) {
      return data.map((item) => {
        return new ActivityCategory(item)
      })
    }
    return requestService.makePromise(route, method, { params, noAuth: true }, map)
  }
  listActivities (categoryId) {
    const route = ServerDirections.ACTIVITIES
    const method = 'get'
    const params = categoryId === null ? { facility_id: APP_FACILITY_ID} : { facility_id: APP_FACILITY_ID, category_id : categoryId}
    function map (data) {
      return data.map((item) => {
        return {
          activity: new Activity(item.activity, item.related_activities ? item.related_activities.map(a => new Activity(a)) : []),
          reservationMethods: item.reservation_methods.map(reservationMethod => {
            return {
              reservationMethod: new ReservationMethod(reservationMethod.activity_reservation_method),
              attendeeTypes: reservationMethod.attendee_types.map((attendeeType) => {
                return new AttendeeType(attendeeType)
              }),
              activityGroup: reservationMethod.activity_group ? new ActivityGroup(reservationMethod.activity_group) : null,
            }
          }),
        }
      })
    }

    return requestService.makePromise(route, method, { params, noAuth: true }, map)
  }
  getActivity (id) {
    const route = ServerDirections.ACTIVITIES_ID.replace('{activityId}', id)
    const method = 'get'
    function map (data) {
      return {
        activity: new Activity(data.activity, data.related_activities ? data.related_activities.map(a => new Activity(a)) : []),
        reservationMethods: data.reservation_methods
          .filter(rM => rM.activity_reservation_method.active)
          .map(rM => {
            const reservationMethod = new ReservationMethod(rM.activity_reservation_method)
            return {
              reservationMethod: reservationMethod.decorateCurrencies(data.currencies),
              attendeeTypes: rM.attendee_types.map((aT) => {
                const attendeeType = new AttendeeType(aT)
                return attendeeType.decorateCurrencies(data.currencies)
              }),
              activityGroup: rM.activity_group ? new ActivityGroup(rM.activity_group) : null,
            }
          }),

        paymentMethodList: camelcaseKeys(data, { deep: true }).paymentMethodList,
      }
    }
    return requestService.makePromise(route, method, { noAuth: true }, map)
  }
  listCapacityPerSlot (id, since, until) {
    const route = ServerDirections.ACTIVITY_ID_SLOTS_CAPACITY.replace('{activityId}', id)
    const method = 'get'
    function map (data) {
      return data.map(item => new SlotCapacity(item))
    }
    const params = { since, until }
    return requestService.makePromise(route, method, { params }, map)
  }
  getCatalog (activityId) {
    const route = ServerDirections.ACTIVITY_ID_CATALOG.replace('{activityId}', activityId)
    const method = 'get'
    function map (data) {
      return new CatalogWithCategoriesAndProducts(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
